/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2015, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../lib/@waca/dashboard-common/dist/glass/controllers/WidgetBaseActionHandler',
	'../../../app/nls/StringResources',
	'../../../lib/@waca/core-client/js/core-client/utils/ClassFactory',
	'underscore'
], function(BaseClass, stringResources, ClassFactory,  _) {

	return BaseClass.extend({

		getDashboardView: function(context) {
			return context.glassContext.appController.getCurrentContentView();
		},

		getUiHelperClass: function(){
			return ClassFactory.loadModule('dashboard-core/js/lib/@waca/dashboard-common/dist/ui/WidgetAddUIHelper');
		},

		getOptions: function(context) {
			const view = this.getDashboardView(context);
			const dashboardApi = view.getDashboardApi();
			const options = {
				module: 'dashboard-core/js/dashboard/views/CustomWidgetListView',
				label: stringResources.get('customWidgetsTitle'),
				getEntries: this.getEntries.bind(this),
				className: 'customWidgetSlideout',
				services: view.services,
				dashboardApi: dashboardApi
			};

			return this._createWidgetAddUIHelper(context, dashboardApi)
				.then( (widgetHelper) => {
					options.onItemClick =  (entry, event) => {
						return this._onItemClickHandler(entry, event, widgetHelper, dashboardApi);
					};
					options.onItemStartDrag = widgetHelper.addWidgetByDrag.bind(widgetHelper);
					return options;
				});
		},

		_onItemClickHandler: function(entry, event, widgetHelper, dashboardApi) {
			const logger = dashboardApi.getFeature('Logger');
			const canvas = dashboardApi.getFeature('Canvas');
			const contentRegistryFeature = dashboardApi.getFeature('ContentTypeRegistry');
			if (contentRegistryFeature.isTypeRegistered(entry.type)) {
				return canvas.addContent(entry.defaultSpec).catch((error) => {
					logger.log(error);
				});
			}
			return widgetHelper.addWidgetBySelection(entry, event);
		},

		getEntries: function(context) {
			const view = this.getDashboardView(context);
			const dashboardApi = view.getDashboardApi();
			const contentRegistryFeature = dashboardApi.getFeature('ContentTypeRegistry');
			return this._createWidgetAddUIHelper(context, dashboardApi)
				.then( (widgetHelper) => widgetHelper.fetchWidgetListFromPerspective('com.ibm.bi.dashboard.widgets'))
				.then( entries => {
					entries.list = _.filter(entries.list, function(entry) {
						return entry.builtin ? false : true;
					});
					entries.list = entries.list.concat(contentRegistryFeature.getExposedContents());
					return entries;
				});
		},

		// Private

		_createWidgetAddUIHelper: function(context, dashboardApi) {
			const view = this.getDashboardView(context);
			const uiHelperClassOptions = {
				services: view.services,
				dashboardApi: dashboardApi
			};

			return this.getUiHelperClass().then( UIHelperClass => {
				const widgetAddUIHelper = new UIHelperClass(uiHelperClassOptions);
				widgetAddUIHelper.panelAttributes = {
					cdnUrl: dashboardApi.getCDNUrl(),
					glassContext: context.glassContext
				};
				return widgetAddUIHelper;
			});
		}

	});
});
